import React, { useState } from "react";
import { Card, Typography, Tag, Button, Space } from "antd";
import { ATSJobPost } from "../../../../../Interface";

const { Title, Text } = Typography;

interface ATSJobPostCardProps {
  jobPost: ATSJobPost;
  onImport: (promptText: string, appJobId: string) => void;
}

const ATSJobPostCard: React.FC<ATSJobPostCardProps> = ({
  jobPost,
  onImport,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const MAX_DESCRIPTION_LENGTH = 200;

  const shouldTruncate = jobPost.description.length > MAX_DESCRIPTION_LENGTH;
  const displayDescription = showFullDescription
    ? jobPost.description
    : jobPost.description.substring(0, MAX_DESCRIPTION_LENGTH);

  const handleImport = () => {
    const promptText = `Job Title: ${jobPost.jobPostTitle}\n\nJob Description: ${jobPost.description}`;
    onImport(promptText, jobPost.jobPostId);
  };

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
      }}
    >
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
          }}
        >
          <Title level={5} style={{ margin: 0, flex: 1 }}>
            {jobPost.jobPostTitle}
          </Title>
          <Tag color={jobPost.isSynced ? "success" : "default"}>
            {jobPost.isSynced ? "Synced" : "Not Synced"}
          </Tag>
        </div>

        <div>
          <Text type="secondary" style={{ fontSize: 14, lineHeight: 1.6 }}>
            {displayDescription}
            {shouldTruncate && !showFullDescription && "..."}
          </Text>
          {shouldTruncate && (
            <Button
              type="link"
              size="small"
              onClick={() => setShowFullDescription(!showFullDescription)}
              style={{ padding: 0, marginLeft: 4, height: "auto" }}
            >
              {showFullDescription ? "Show Less" : "View More"}
            </Button>
          )}
        </div>

        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}
        >
          <Button
            type="primary"
            onClick={handleImport}
            disabled={jobPost.isSynced}
          >
            Import
          </Button>
        </div>
      </Space>
    </Card>
  );
};

export default ATSJobPostCard;
